/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Process_PlaceholderInputs */

const en_search_process_placeholder = /** @type {(inputs: Search_Process_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search process...`)
};

const es_search_process_placeholder = /** @type {(inputs: Search_Process_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buscar proceso...`)
};

/**
* | output |
* | --- |
* | "Search process..." |
*
* @param {Search_Process_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const search_process_placeholder = /** @type {((inputs?: Search_Process_PlaceholderInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Process_PlaceholderInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_search_process_placeholder(inputs)
	return es_search_process_placeholder(inputs)
});